var settings = {

	// Default color for background images
	defaultBackground: {
		"key": "grey",
		"preview": "grey",
		"border": "1px solid rgba(0, 0, 0, 0.1)"
	},

	standardApiUrl: "",

	wgURL: '', // Change to local url if dev localy, leave empty in production

	// Image url
	productImageUrl: 'https://media.desenio.com/site_images',

    frameImageUrl: 'https://images.desenio.com/zoom/',

	// Image cloud upload url (standard)
	imageCloudUrl: "//res.cloudinary.com/desenio/image/upload/",

	// Image cloud backgrounds url
	imageCloudBackgroundUrl: "//res.cloudinary.com/desenio/image/upload/v1502888905/backgrounds/",

	getResizedImageFromCloud(width, file, folder){

		if(typeof folder == 'undefined')
			var folder = "";

		return this.imageCloudUrl + "w_"+width+"/"+ folder + file
	},

	getWGUrl: function(){
		return this.wgURL;
	},

	getUrl: function(){

		var url = this.standardApiUrl;

		if(typeof window.appApi != 'undefined' && window.appApi != '<apiURL>'){
			url = window.appApi;
		}

		if(typeof window.enviroment != 'undefined' && window.enviroment == 'production')
		{
			url = "";
		}

		this.url = url;

		return url;

	},

	getImageCloudUrl: function(){

		var url = this.imageCloudUrl; // The default url for local development
		return url;

	},

}


module.exports = settings;



// WEBPACK FOOTER //
// ./client/settings.js